<div class="case-manager-result">
  <div class="case-manager-result__header">
    <span class="case-manager-result__count"
      >{{ cases().length }} {{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.CASES' | translate }}</span
    >
    <div class="case-manager-result__actions">
      <ui-button
        size="s"
        type="noBorderDefault"
        iconClass="ui-icon-new-tab"
        [matTooltip]="'SEARCH_GLOBAL_MODAL.CASE_MANAGER.OPEN_LIST' | translate"
        (clickAction)="openCaseList()"
      ></ui-button>
      <ui-button
        size="s"
        type="primary"
        [text]="'CASES.CREATE_CASE' | translate"
        (clickAction)="createCase()"
      ></ui-button>
    </div>
  </div>

  <div class="case-manager-result__filters">
    <ui-search
      class="case-manager-result__search"
      [placeholder]="'CASES.SEARCH_CASE' | translate"
      [searchQuery]="searchQuery()"
      (onInput)="onSearchQuery($event)"
    ></ui-search>

    <mat-select
      class="ui-selector case-manager-result__filter-control"
      multiple
      [value]="selectedStatuses()"
      [placeholder]="'CASES.TABLE.STATUS' | translate"
      (selectionChange)="onStatusChange($event)"
    >
      <mat-option *ngFor="let status of caseStatuses" [value]="status">
        {{ caseStatusDisplayMap[status] | translate }}
      </mat-option>
    </mat-select>

    <app-tag-filter
      class="case-manager-result__filter-control"
      [selectWidth]="'100%'"
      [formControl]="tagsFilterControl"
      [isCreateButtonVisibleSig]="false"
    ></app-tag-filter>
  </div>

  <div class="case-manager-result__chips" *ngIf="hasActiveFilters()">
    <span
      class="ui-icon-cross case-manager-result__clear-filters"
      [matTooltip]="'COMMON.CLEAR_FILTERS' | translate"
      (click)="clearFilters()"
    ></span>

    <ui-filter-chip
      *ngIf="searchQuery()"
      [title]="searchQuery()"
      (removeClicked)="removeSearch()"
    ></ui-filter-chip>

    <ui-filter-chip
      *ngFor="let status of selectedStatuses()"
      [title]="caseStatusDisplayMap[status] | translate"
      (removeClicked)="removeStatus(status)"
    ></ui-filter-chip>

    <ui-filter-chip
      *ngFor="let tagId of selectedTags()"
      [title]="tagEntities()[tagId]?.name || tagId"
      (removeClicked)="removeTag(tagId)"
    ></ui-filter-chip>
  </div>

  <div class="case-manager-result__filtering" *ngIf="isFiltering()">
    <ui-preloader [color]="PreloaderColor.blue" [diameter]="40"></ui-preloader>
  </div>

  <ng-container *ngIf="!isFiltering()">
    <div class="case-manager-result__empty" *ngIf="cases().length === 0">
      {{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.NO_CASES' | translate }}
    </div>

    <div
      class="case-row"
      *ngFor="let item of cases(); trackBy: trackByCaseId"
      [class.case-row--expanded]="expandedCaseId() === item._id"
    >
    <div class="case-row__head">
      <button class="case-row__summary" type="button" (click)="toggleExpand(item._id)">
        <span class="case-row__left">
          <span class="case-row__name" [title]="item.name">{{ item.name }}</span>
          <span class="case-row__incident">{{ incidentNumber(item) }}</span>
        </span>

        <span class="case-row__right">
          <span class="case-row__status">{{ item.status }}</span>
          <span class="case-row__date">{{ item.createdAt | date: 'mediumDate' }}</span>
        </span>
      </button>

      <span class="case-row__menu">
        <ui-preloader
          *ngIf="deletingCaseId() === item._id; else menuTrigger"
          [color]="PreloaderColor.gray"
          [diameter]="18"
        ></ui-preloader>
        <ng-template #menuTrigger>
          <span
            class="case-row__menu-icon ui-icon-more-menu"
            [matMenuTriggerFor]="caseMenu"
            (click)="$event.stopPropagation()"
          ></span>
        </ng-template>
      </span>
    </div>

    <mat-menu #caseMenu="matMenu" xPosition="before">
      <button mat-menu-item type="button" (click)="goToCase(item)">
        {{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.GO_TO_CASE' | translate }}
      </button>
      <button *ngIf="canEditCase(item)" mat-menu-item type="button" (click)="editCase(item)">
        {{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.EDIT_CASE' | translate }}
      </button>
      <button *ngIf="canEditCase(item)" mat-menu-item type="button" (click)="deleteCase(item)">
        {{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.DELETE_CASE' | translate }}
      </button>
    </mat-menu>

    <div class="case-row__detail" *ngIf="expandedCaseId() === item._id">
      <div class="detail-item">
        <span class="detail-label">{{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.DESCRIPTION' | translate }}</span>
        <span class="detail-value">{{ item.description || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.ADDRESS' | translate }}</span>
        <span class="detail-value">{{ item.location?.address || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.START_TIME' | translate }}</span>
        <span class="detail-value">{{ item.startTime ? (item.startTime | date: 'medium') : '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.END_TIME' | translate }}</span>
        <span class="detail-value">{{ item.endTime ? (item.endTime | date: 'medium') : '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'SEARCH_GLOBAL_MODAL.CASE_MANAGER.OWNER' | translate }}</span>
        <span class="detail-value">{{ ownerName(item) }}</span>
      </div>
      <div class="case-row__features">
        <button
          class="case-feature"
          *ngFor="let feature of featureItems"
          type="button"
          [disabled]="isFeatureDisabled(item, feature.id)"
          (click)="openFeature(item, feature.id)"
        >
          <span class="case-feature__label">{{ feature.labelKey | translate }}</span>
          <span class="case-feature__badge">
            {{ featureCount(item._id, feature.id) }}
          </span>
        </button>
      </div>
    </div>
    </div>
  </ng-container>
</div>
